import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box } from '@mui/material';
import VideoBlock from '../VideoBlock/VideoBlock';

function MediaCard({ preview, video, description }) {
  return (
    <Box>
      <VideoBlock video={video} description={description} card>
        <GatsbyImage image={getImage(preview)} alt="" loading="lazy" />
      </VideoBlock>
    </Box>
  );
}

export default MediaCard;
